import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 mt-24" data-testid="site-footer">
      <div className="h-1 gfe-gradient-bg" />
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14">
          <div className="md:col-span-6">
            <h3 className="font-display text-4xl md:text-5xl font-extrabold text-white leading-none">
              Let&apos;s <span className="gfe-gradient-text">source smarter</span> together.
            </h3>
            <p className="mt-5 text-slate-400 max-w-lg">
              From a single fitting to a full production line — talk to our sourcing desk and get a competitive quote within 24 hours.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/quote" data-testid="footer-request-quote" className="btn-orange inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold">
                Request a Quote <ArrowUpRight className="w-4 h-4" />
              </Link>
              <a href={SITE.catalogue} target="_blank" rel="noreferrer" data-testid="footer-catalogue" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium border border-slate-700 hover:border-slate-500 transition text-white">
                Download Catalogue
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Explore</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/products" className="hover:text-white">Products</Link></li>
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><Link to="/admin" className="hover:text-white text-slate-500">Admin</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-slate-500 mb-4">Reach us</div>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 shrink-0" /><a href={`tel:${SITE.phone}`} className="hover:text-white">{SITE.phone}</a></li>
              <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 shrink-0" /><a href={`mailto:${SITE.email}`} className="hover:text-white break-all">{SITE.email}</a></li>
              <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0" /><span>{SITE.address}</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Green Fuse Energy · All rights reserved · GSTIN {SITE.gstin}</div>
          <div className="flex items-center gap-2">
            <img src={SITE.logo} alt="logo" className="h-6 w-auto opacity-90" />
            <span>Your Global Partner in Industrial Solutions</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
